<template>
  <div>
    <Head title="SKUs" />
    <h1 class="mb-8 text-3xl font-bold">SKUs</h1>
    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset" />
      <Link class="btn-orange" href="/skus/create">
        <span>Create</span>
        <span class="hidden md:inline">&nbsp;Sku</span>
      </Link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-3 pt-3 px-3">Part Number</th>
          <th class="pb-3 pt-3 px-3">Part Description</th>
          <th class="pb-3 pt-3 px-3">Category</th>
          <th class="pb-3 pt-3 px-3 text-center">Standard Quantity</th>
          <th class="pb-3 pt-3 px-3 text-center">CBM</th>
          <th class="pb-3 pt-3 px-3 text-center">Min. Quantity</th>
          <th class="pb-3 pt-3 px-3">UoM</th>
          <th class="pb-3 pt-3 px-3">Status</th>
          <th class="pb-3 pt-3 px-3" colspan="2" />
        </tr>
        <tr v-for="sku in skus.data" :key="sku.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
          <td class="border-t">
            <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/skus/${sku.id}/edit`">
              {{ sku.name }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3" href="#" tabindex="-1">
              {{ sku.description }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3" href="#" tabindex="-1">
              {{ sku.category }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center justify-center w-full" href="#" tabindex="-1">
              {{ sku.standard_quantity ? sku.standard_quantity : '-' }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center justify-center w-full" href="#" tabindex="-1">
              {{ sku.cbm }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center justify-center w-full" href="#" tabindex="-1">
              {{ sku.minimum_qty }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3" href="#" tabindex="-1">
              {{ sku.unit_of_measure }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3" href="#" tabindex="-1">
              {{ sku.status }}
            </Link>
          </td>
          <td class="w-px border-t">
            <Link class="flex items-center px-3" href="#" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </Link>
          </td>
        </tr>
        <tr v-if="skus.data.length === 0">
          <td class="px-3 py-3 border-t" colspan="4">No data found</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="skus.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchFilter from '@/Shared/SearchFilter'
import Pagination from '@/Shared/Pagination'

export default {
  components: {
    Head,
    Icon,
    Link,
    SearchFilter,
    Pagination,
  },
  layout: Layout,
  props: {
    filters: Object,
    skus: Array,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/skus', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
